/**
 * Pure plan-limit predicates.
 *
 * Kept separate from hooks.ts so tests can import without pulling the
 * supabase client (which throws at module-load time when env vars are
 * absent — same pattern as features/contacts/profile-sections.ts).
 *
 * Two helpers with OPPOSITE semantics:
 *   - _featureEnabled (gates): absent key = ENABLED. Only `false` disables.
 *   - _featureAddonEnabled (addons): absent key = DISABLED. Only `true` enables.
 *
 * See the spec at docs/superpowers/specs/2026-06-13-relay-mlm-module-design.md
 * § 1 + Appendix A for why this asymmetry exists.
 */

export function _featureEnabled(
  gates: Record<string, unknown> | null | undefined,
  key: string,
): boolean {
  if (!gates) return true;           // no restrictions object
  if (!(key in gates)) return true;  // absent key = default enabled (gates only DISABLE)
  return gates[key] === true;        // only explicit true passes; false/other = disabled
}

export function _featureAddonEnabled(
  addons: Record<string, unknown> | null | undefined,
  key: string,
): boolean {
  if (!addons) return false;            // no row → off
  if (!(key in addons)) return false;   // absent key → off (OPPOSITE of feature_gates)
  return addons[key] === true;          // only explicit true enables
}
